import { injectIntl } from 'react-intl';
import PassengerSelection from './PassengerSelection';

export default injectIntl(PassengerSelection);
